<template>
  <div>
    <PageImage v-if="!loading" :src="event.image" alt="" />
    <PageContent :top-sticked="true" :loading="loading">
      <Container v-if="event">
        <p
          class="space-t-2 text-xs"
          v-html="$options.filters.breakLine(event.comment)"
        />

        <form class="space-t-6" v-bind:class="'event-check-tag_' + type" @submit.prevent="onSubmit">
          <NoticeBox type="error" v-if="hasErrors">
            {{ invalidMessage }}
          </NoticeBox>

          <EventDateTimeCheckList
            v-if="isTypeItems"
            v-model="postData.event_id"
            :date-list="event.date_list"
            :error-date="getErrors('dateSelected')"
            :error-time="getErrors('postData.event_id')"
            @dateSelected="onDateSelected"
          />
          <EventDateCheckList
            v-else
            v-model="postData.event_id"
            :date-list="event.date_list"
            :error="getErrors('postData.event_id')"
          />
          <div class="form-group event-form-group2">
            <label for="count">
              ご新郎、ご新婦も含めたご参加人数をご入力ください。<br />
              <span  v-if="!isTypeFoods">親族の方以外も参加可能です。</span>
            </label>
            <div class="select is-fullwidth">
              <select
                id="count"
                class="form-control"
                :class="{ 'has-error': hasError('postData.reserve_count') }"
                v-model.number="postData.reserve_count"
                :disabled="availableCount === 0"
              >
                <option value="0">人数を選択</option>
                <option
                  v-for="num in availableCount"
                  :key="num"
                  :value="num"
                >{{ num }}人</option>
              </select>
            </div>
            <FormError :errors="getErrors('postData.reserve_count')" />
          </div>
          <div class="form-group event-form-group3" v-if="isTypeFoods || isTypeOther || isTypeStartMeeting">
            <label for="contact">ご連絡先をご入力ください。</label>
            <div class="select is-fullwidth">
              <select
                id="contact"
                class="form-control"
                :class="{ 'has-error': hasError('postData.contact') }"
                v-model.number="postData.contact"
              >
                <option value="0">連絡先を選択</option>
                <option value="1">新郎様</option>
                <option value="2">新婦様</option>
              </select>
            </div>
            <FormError :errors="getErrors('postData.contact')" />
          </div>
          <div class="form-group event-form-group4" v-if="isTypeFoods">
            <label for="member">
              ご参加される方にチェックを入れてください。
            </label>
            <ul class="check-list space-t-2">
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_groom"
              >
                <label for="reserve_groom" class="checkbox">
                  <input
                    id="reserve_groom"
                    type="checkbox"
                    v-model="postData.reserve_groom"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新郎様</span>
                </label>
              </li>
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_bride"
              >
                <label for="reserve_bride" class="checkbox">
                  <input
                    id="reserve_bride"
                    type="checkbox"
                    v-model="postData.reserve_bride"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新婦様</span>
                </label>
              </li>
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_groom_father"
              >
                <label for="reserve_groom_father" class="checkbox">
                  <input
                    id="reserve_groom_father"
                    type="checkbox"
                    v-model="postData.reserve_groom_father"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新郎家お父様</span>
                </label>
              </li>
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_groom_mother"
              >
                <label for="reserve_groom_mother" class="checkbox">
                  <input
                    id="reserve_groom_mother"
                    type="checkbox"
                    v-model="postData.reserve_groom_mother"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新郎家お母様</span>
                </label>
              </li>
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_bride_father"
              >
                <label for="reserve_bride_father" class="checkbox">
                  <input
                    id="reserve_bride_father"
                    type="checkbox"
                    v-model="postData.reserve_bride_father"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新婦家お父様</span>
                </label>
              </li>
              <li
                class="check-list-item"
                v-if="!eventSelected || selectedEvent.reservable_bride_mother"
              >
                <label for="reserve_bride_mother" class="checkbox">
                  <input
                    id="reserve_bride_mother"
                    type="checkbox"
                    v-model="postData.reserve_bride_mother"
                    :disabled="!eventSelected"
                  />
                  <span class="checkbox-text">新婦家お母様</span>
                </label>
              </li>
            </ul>
          </div>
          <div class="form-group event-form-group5" v-if="allergyConfirmation">
            <label>参加者に食材アレルギーがある方がいらっしゃいますか？</label>
            <div class="radio-list">
              <label for="allergy-yes" class="radio">
                <input
                  id="allergy-yes"
                  type="radio"
                  value="1"
                  v-model.number="postData.has_allergy"
                >
                <span class="radio-text">はい</span>
              </label>
              <label for="allergy-no" class="radio">
                <input
                  id="allergy-no"
                  type="radio"
                  value="0"
                  v-model.number="postData.has_allergy"
                >
                <span class="radio-text">いいえ</span>
              </label>
            </div>
            <FormError :errors="getErrors('postData.has_allergy')" />
            <p class="form-memo event-form-memo">
              「はい」とご回答いただいた場合は、下記の備考欄に<span>アレルギー情報</span>のご記入をお願い致します。
            </p>
          </div>
          <div class="form-group event-form-group6">
            <div class="remarks_label" v-html="remarksLabel" ref="content" />
            <textarea
              id="note"
              class="form-control is-multiline"
              :class="{ 'has-error': hasError('postData.customer_memo') }"
              v-model="postData.customer_memo"
              :rows="postData.customer_memo.split(/\n/).length"
            ></textarea>
            <FormError :errors="getErrors('postData.customer_memo')" />
          </div>
          <div class="form-footer text-center">
            <WaveButton
              type="submit"
              class="button"
              :loading="submitLoading"
              :disabled="submitDisabled"
            >
              予約する
            </WaveButton>
          </div>
        </form>
      </Container>
    </PageContent>

    <Modal
      id="reserve-complete"
      title="イベントの予約が完了しました"
      icon="check"
      @ok="ok"
    />
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import NoticeBox from '@/components/NoticeBox.vue'
import FormError from '@/components/FormError.vue'
import EventDateCheckList from '@/components/EventDateCheckList'
import EventDateTimeCheckList from '@/components/EventDateTimeCheckList'
import { renderError } from '@/utils/error'
import { breakLine } from '@/utils/dom'
import eventApi from '@/api/event'
import validationMixin from '@/mixins/validation'
import { sanitizeHTML } from '@/utils/dom'
import initInjectedHTML from '@/utils/init-injected-html'

const EVENT_TYPE_FOODS = 4
const EVENT_TYPE_ITEMS = 5
const EVENT_TYPE_OTHER = 10
const EVENT_TYPE_STARTMEETING = 6

const initialState = {
  reserve_count: 0,
  contact: 0,
  reserve_groom: false,
  reserve_bride: false,
  reserve_groom_father: false,
  reserve_groom_mother: false,
  reserve_bride_father: false,
  reserve_bride_mother: false,
  has_allergy: null,
  customer_memo: '',
  event_id: 0,
  event_revision: null,
}

const isEmpty = val => val === 0 || val === null

export default {
  props: {
    event: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null,
    },
    type: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Modal,
    NoticeBox,
    FormError,
    EventDateCheckList,
    EventDateTimeCheckList,
  },

  mixins: [
    validationMixin
  ],

  rules(vm) { 
    const selectboxRule = handler => {
      return [{ handler }, { deny: [0] }, '$name$を選択してください。']
    }

    return {
      'dateSelected': ['開催日', [
        selectboxRule(vm.eventDateValidator)
      ]],
      'postData.event_id': ['開催日時', [
        selectboxRule(vm.eventDateTimeValidator)
      ]],
      'postData.reserve_count': ['参加人数', [
        selectboxRule(vm.reserveCountValidator)
      ]],
      'postData.contact': ['連絡先', [
        selectboxRule(vm.contactValidator)
      ]],
      'postData.has_allergy': ['どちらか', [
        selectboxRule(vm.hasAllergyValidator)
      ]],
      'postData.customer_memo': ['備考欄', [
        [{ handler: vm.customerMemoValidator }, { deny: [0] }, '$name$を入力してください。']
      ]],
    }
  },

  filters: {
    breakLine,
  },

  data() {
    return {
      postData: initialState,
      submitLoading: false,
      submitDisabled: false,
      dateSelected: false
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    isTypeItems() {
      return this.type === EVENT_TYPE_ITEMS
    },
    isTypeFoods() {
      return this.type === EVENT_TYPE_FOODS
    },
    isTypeOther() {
      return this.type === EVENT_TYPE_OTHER
    },
    isTypeStartMeeting() {
      return this.type === EVENT_TYPE_STARTMEETING
    },
    allergyConfirmation() {
      return this.event.allergy_confirmation
    },
    startTimeList() {
      if (!this.event) {
        return []
      }

      return this.event.date_list.reduce((prev, current) => {
        return [...prev, ...current.start_time_list]
      }, [])
    },
    selectedTime() {
      return this.startTimeList.find(item => {
        return item.event_id === this.postData.event_id
      })
    },
    eventSelected() {
      return this.postData.event_id !== 0
    },
    selectedEvent() {
      return this.event.date_list.find(date => {
        return date.start_time_list.some(item => {
          return item.event_id === this.postData.event_id
        })
      })
    },
    availableCount() {
      return this.selectedTime ? this.selectedTime.available_count : 0
    },
    eventRevision() {
      return this.selectedTime ? this.selectedTime.event_revision : 0
    },
    remarksLabel() {
      if (this.event) {
        return sanitizeHTML(this.event.remarks_label)
      } else {
        return ''
      }
    }
  },

  methods: {
    eventDateValidator(val, param, msg) {
      if (this.isTypeFoods || this.isTypeOther || this.isTypeStartMeeting) {
        return [true]
      }

      return val ? [true] : [false, msg]
    },
    eventDateTimeValidator(val, param, msg) {
      if (this.isTypeItems && !this.dateSelected) {
        return [true]
      }

      const message = this.isTypeItems ? '開始時間を選択してください。' : msg

      return isEmpty(val) ? [false, message] : [true]
    },
    reserveCountValidator(val, param, msg) {
      if (this.postData.event_id === 0) {
        return [true]
      }

      return isEmpty(val) ? [false, msg] : [true]
    },
    contactValidator(val, param, msg) {
      if (this.isTypeItems) {
        return [true]
      }

      return isEmpty(val) ? [false, msg] : [true]
    },
    hasAllergyValidator(val, param, msg) {
      if (!this.allergyConfirmation) {
        return [true]
      }
      return val === null ? [false, msg] : [true]
    },
    customerMemoValidator(val, param, msg) {
      if (!this.postData.has_allergy) {
          return [true]
      }
      return val.length === 0 ? [false, msg] : [true]
    },
    onDateSelected() {
      this.dateSelected = true
    },
    async onSubmit() {
      if (this.submitLoading) {
        return false
      }

      if (!this.validate()) {
        window.scrollTo(0, 0)
        return false
      }

      this.submitLoading = true
      this.submitDisabled = true

      try {
        const { event_id, ...data } = this.postData
        data.has_allergy = Boolean(data.has_allergy)
        data.event_revision = this.eventRevision
        await eventApi.reserve(this.businessId, event_id, data)

        this.$modal.show('reserve-complete')
      } catch(err) {
        renderError(err, {
          onErrorPopupClose: () => this.$emit('reserve-complete'),
        })
      } finally {
        this.submitLoading = false
      }
    },
    ok() {
      this.$emit('reserve-complete')
      this.$modal.close('reserve-complete')
    },
  },

  watch: {
    type: {
      handler() {
        this.clearErrors()

        this.postData = Object.assign(
          {},
          initialState,
          this.isTypeFoods ? {
            reserve_groom: false,
            reserve_bride: false,
            reserve_groom_father: false,
            reserve_groom_mother: false,
            reserve_bride_father: false,
            reserve_bride_mother: false,
          } : {}
        )

        this.submitDisabled = false
      },
      immediate: true,
    },
    remarksLabel: {
      handler() {
        this.$nextTick(() => {
          initInjectedHTML(this.$refs.content)
        })
      }
    },
    'postData.event_id': {
      handler(){
        this.postData.reserve_count = 0
        this.postData.reserve_groom = false
        this.postData.reserve_bride = false
        this.postData.reserve_groom_father = false
        this.postData.reserve_groom_mother = false
        this.postData.reserve_bride_father = false
        this.postData.reserve_bride_mother = false
      },
    },
  },
}
</script>
